import request from "../../../../Helpers/API";
import { extraerMensajeError } from "../../../../Helpers/ErrorHelper";

// Cliente HTTP de Objetivos Semanales CRM. request.get/post (Helpers/API.js) ya agregan
// "Authorization: Bearer <token>" (localStorage) y manejan 401 de forma global (redirige a
// /auth/login), por eso aquí no se repite esa lógica.

// Re-exportado para no romper los imports existentes: el normalizador de errores vive ahora en
// Helpers/ErrorHelper.js (se movió ahí para que IndicadoresVisitasCRMService también lo reuse).
export { extraerMensajeError };

export const ObjetivosSemanalesCRMService = {
  // GET /Listado — arreglo plano semana/vendedor/línea, ejes para el pivot del grid.
  listado: (ejercicio, periodo) =>
    request.get(`ObjetivosSemanalesCRM/Listado?ejercicio=${ejercicio}&periodo=${periodo}`),

  // POST /Guardar — { ejercicio, periodo, detalle, comentarios }. "usuario" y "Total
  // Cotizaciones" nunca se mandan: el usuario lo toma el backend del token, el total se calcula
  // solo en pantalla. "comentarios" es opcional, capturado en un modal antes de guardar.
  guardar: ({ ejercicio, periodo, detalle, comentarios }) =>
    request.post("ObjetivosSemanalesCRM/Guardar", { ejercicio, periodo, detalle, comentarios: comentarios || "" }),

  // GET /GenerarSemanas — genera las semanas del ejercicio; no regresa las semanas, hay que
  // volver a llamar Listado después.
  generarSemanas: (ejercicio) =>
    request.get(`ObjetivosSemanalesCRM/GenerarSemanas?ejercicio=${ejercicio}`),
};
